<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';

const props = defineProps<{
  configData: object;
  keys: any;
  typeOption?: string;
  cruiseKey?: any;
}>();

const emits = defineEmits<{
  handleSubmit: [value: any];
  'update:configData': [value: any];
}>();

const configData: any = computed({
  get() {
    return props.configData;
  },
  set(value) {
    emits('update:configData', value);
  }
});

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const { t } = useI18n({ useScope: 'global' });

const handleUpdateConfig = (configData: any) => {
  emits('handleSubmit', configData);
};

const keyValue = computed(() => {
  return configData.value.keyName === 'cruiseTempOptionConfig' ? props.cruiseKey : props.keys;
});

const isDisable = computed(() => {
  return authorizations?.configurationPage?.configurable_items_edit;
});

const getTitle = (title: string) => {
  if (props.typeOption === 'room') {
    switch (title) {
      case 'hotelOptionConfig':
        return t('management.email.hotel_quote');
      case 'cruiseOptionConfig':
        return t('quote_config.cruise_pre_post_hotel');
      default:
        return t('management.email.package_quote');
    }
  } else if (props.typeOption === 'hotel') {
    switch (title) {
      case 'hotelOptionConfig':
        return t('management.email.hotel_quote');
      case 'cruiseOptionConfig':
        return t('quote_config.cruise_pre_post_hotel');
      case 'cruiseTempOptionConfig':
        return t('quote_config.cruise_categories');
      default:
        return t('management.email.package_quote');
    }
  } else {
    switch (title) {
      case 'hotelOptionConfig':
        return t('management.email.hotel_quote');
      case 'airOptionConfig':
        return t('management.email.air_quote');
      case 'cruiseOptionConfig':
        return t('management.email.cruise_quote');
      case 'mdtOptionConfig':
        return t('advance_quote.form.multi_day_tour');
      default:
        return t('management.email.package_quote');
    }
  }
};
</script>
<template>
  <div class="option-config-number">
    <div class="flex mb-3 input-number-field">
      <div class="align-self-center mr-3 w-10rem">
        <div>{{ getTitle(configData.keyName) }}</div>
      </div>
      <InputNumber :disabled="!isDisable" v-model="configData[keyValue]" :min="1" :placeholder="$t('common.7days')" class="mr-3 input-number"></InputNumber>
      <Button v-if="isDisable" :label="$t('promos.save')" icon="pi pi-check save-btn" class="mr-2 bg-primary" @click="handleUpdateConfig(configData)" />
    </div>
  </div>
</template>
